export default {
  'zh_CN': {
    'travel.car-rule.id.label': '车辆出入规则',
    'travel.car-rule.id.holder': '请输入车辆出入规则',

    'travel.car-rule.id.required': '车辆出入规则必填',
    'travel.car-rule.plateNo.label': '车牌号',
    'travel.car-rule.plateNo.holder': '请输入车牌号',
    'travel.car-rule.plateNo.max': '车牌号最多10个字符',

    'travel.car-rule.plateNo.required': '车牌号必填',
    'travel.car-rule.rule.label': '规则',
    'travel.car-rule.rule.holder': '请输入规则',
    'travel.car-rule.rule.max': '规则最多1024个字符',
    'travel.car-rule.rule.required': '规则必填',
    'travel.car-rule.createTime.label': '创建时间',
    'travel.car-rule.createTime.holder': '请输入创建时间',
    'travel.car-rule.createTime.required': '创建时间必填',
    'travel.car-rule.updateTime.label': '更新时间',
    'travel.car-rule.updateTime.holder': '请输入更新时间',
    'travel.car-rule.updateTime.required': '更新时间必填',
    'travel.car-rule.isDelete.label': '删除时间戳',
    'travel.car-rule.isDelete.holder': '请输入删除时间戳',

    'travel.car-rule.isDelete.dictionary': () => [{ value: 0, label: '删除' }],
    'travel.car-rule.isDelete.required': '删除时间戳必填'
  },
  'zh_TW': {
    'travel.car-rule.id.label': '车辆出入规则',
    'travel.car-rule.id.holder': '請輸入车辆出入规则',

    'travel.car-rule.id.required': '车辆出入规则必填',
    'travel.car-rule.plateNo.label': '车牌号',
    'travel.car-rule.plateNo.holder': '請輸入车牌号',

    'travel.car-rule.plateNo.required': '车牌号必填',
    'travel.car-rule.rule.label': '规则',
    'travel.car-rule.rule.holder': '請輸入规则',

    'travel.car-rule.rule.required': '规则必填',
    'travel.car-rule.createTime.label': '创建时间',
    'travel.car-rule.createTime.holder': '請輸入创建时间',

    'travel.car-rule.createTime.required': '创建时间必填',
    'travel.car-rule.updateTime.label': '更新时间',
    'travel.car-rule.updateTime.holder': '請輸入更新时间',

    'travel.car-rule.updateTime.required': '更新时间必填',
    'travel.car-rule.isDelete.label': '删除时间戳',
    'travel.car-rule.isDelete.holder': '請輸入删除时间戳',

    'travel.car-rule.isDelete.required': '删除时间戳必填'
  },
  'en_US': {
    'travel.car-rule.id.label': 'id',
    'travel.car-rule.id.holder': 'Enter id',
    'travel.car-rule.id.max': 'id max length: 车辆出入规则',

    'travel.car-rule.id.required': 'id required',
    'travel.car-rule.plateNo.label': 'plateNo',
    'travel.car-rule.plateNo.holder': 'Enter plateNo',
    'travel.car-rule.plateNo.max': 'plateNo max length: 车牌号',

    'travel.car-rule.plateNo.required': 'plateNo required',
    'travel.car-rule.rule.label': 'rule',
    'travel.car-rule.rule.holder': 'Enter rule',
    'travel.car-rule.rule.max': 'rule max length: 规则',

    'travel.car-rule.rule.required': 'rule required',
    'travel.car-rule.createTime.label': 'createTime',
    'travel.car-rule.createTime.holder': 'Enter createTime',
    'travel.car-rule.createTime.max': 'createTime max length: 创建时间',

    'travel.car-rule.createTime.required': 'createTime required',
    'travel.car-rule.updateTime.label': 'updateTime',
    'travel.car-rule.updateTime.holder': 'Enter updateTime',
    'travel.car-rule.updateTime.max': 'updateTime max length: 更新时间',

    'travel.car-rule.updateTime.required': 'updateTime required',
    'travel.car-rule.isDelete.label': 'isDelete',
    'travel.car-rule.isDelete.holder': 'Enter isDelete',
    'travel.car-rule.isDelete.max': 'isDelete max length: 删除时间戳',

    'travel.car-rule.isDelete.required': 'isDelete required'
  }
}
